import request from '@/common/utils/request'

export function getCourses(category) {
    // 获得course列表
    return request({
        url: `/api/challenge/?tags=${category}`,
        method: 'GET',
    })
}

export function getCourse(cid) {
    // 获得course详情
    return request({
        url: `/api/challenge/${cid}/`,
        method: 'GET',
    })
}

export function cleanCycleDelete(cid, course) {
    // 重置cycle
    return request({
        url: `/api/cycle/${cid}/`,
        method: 'DELETE',
        params: {
            course
        }
    })
}

export function getCycles(course) {
    // 获得course的cycle列表
    return request({
        url: `/api/cycle/`,
        method: 'GET',
        params: {
            course
        }
    })
}

export function getMissionDetail(mid) {
    // 获得Mission详情
    return request({
        url: `/api/mission/${mid}/`,
        method: 'GET',
    })
}

export function uploadAnswerImage(serverId) {
    // 上传挑战图片
    return request({
        url: `/api/upload/`,
        method: 'POST',
        data: {
            serverId
        }
    })
}

export function uploadShareImage(b64string, mid) {
    // 上传分享图片
    return request({
        url: `/api/upload/b64/${mid}/`,
        method: 'POST',
        data: {
            b64string
        }
    })
}

export function confirmAnswer(answer, answer_img, mid, teacher_rating, task_rating) {
    // 确认挑战答案
    return request({
        url: `/api/mission/${mid}/`,
        method: 'POST',
        data: {
            answer,
            answer_img,
            teacher_rating,
            task_rating,
        }
    })
}

export function getProduct(pid) {
    // 获得商品详细信息
    return request({
        url: `/api/product/${pid}/`,
        method: 'GET',
    })
}

export function getProductList(category) {
    // 获得商品列表 category=1,2,3,4
    return request({
        url: `/api/product/?tags=${category}`,
        method: 'GET',
    })
}

export function unlockProduct(pid, payBy) {
    // 解锁商品
    return request({
        url: `/api/unlock/product/${pid}/`,
        method: 'POST',
        data: {
            payBy
        }
    })
}

export function getCoachList() {
    // 所有教师
    return request({
        url: `/api/coach/`,
        method: 'GET',
    })
}

export function getOrderList() {
    // 我的订单信息
    return request({
        url: `/api/order/`,
        method: 'GET',
    })
}


